import angular from "angular";

angular
	.module('app')
	.component('notificationDirectReplyForComment', {
		template: require('./notification-direct-reply-for-comment.html'),
        controller: ['$http', controller],
        bindings: {
			resolve: '<',
			close: '&',
			dismiss: '&'
        }
    });

function controller($http) {

	let $ctrl = this;

	$ctrl.$onInit = function () {
		$ctrl.notify = $ctrl.resolve.notification;
	};

}